import { POST_REGISTER_USER, GET_INFO_USER, POST_REGISTER_USER_PROD, GET_INFO_USER_PROD, POST_REGISTER_USER_PREPROD, GET_INFO_USER_PREPROD} from '../constants/routes';

export const sendInfoRegisterUser = async (user, code) => {
	try {
			const options = { 
				method: 'PUT',
				 headers: {
		 		 	// 'invitation_code': `${code}`,
		 		 	'Content-type': 'application/json'
		 		 },
				body: JSON.stringify(user),
				mode: 'cors'
			};
			const response =  await fetch(POST_REGISTER_USER_PROD(code), options)
			const data = response.json();

			return data;
	}
	catch (e) {
		console.log('error:', e)
	}
}

export const getEmailByCode = async (otp) => {
	try {
		 console.log(otp)
		 	const options = {
		 		method: "GET",
		 		// headers: {
		 		// 	Authorization: `${otp}`,
		 		// 	'Content-type': 'application/json'
		 		// },
		 		mode: 'cors'
		 	}

		 	const response =  await fetch (GET_INFO_USER_PROD(otp), options);
		 	const data = response.json();
		 	return data;
	}
	catch (e) {
		console.log('error:', e)
	}
}
